import Vue from 'vue';

export default {
  toggleDrawer(state) {
    state.drawerVisible = !state.drawerVisible;
  },
  setSnackbarProps(state, {
    text = '', color = '', timeout = 4000, show = true,
  }) {
    state.snackbar.text = text;
    state.snackbar.color = color;
    state.snackbar.timeout = timeout;
    state.snackbar.show = show;
  },
  setHiddenFields(state, { domain, fields }) {
    Vue.set(state.hiddenFields, domain, fields);
  },
  /* Sets the menu items. */
  setDrawerItems(state, { drawerItems }) {
    state.drawerItems = drawerItems;
  },
  setCurrentUser(state, username) {
    state.currentUser = username;
  },
  setUser(state, data) {
    state.user = data;
  },
};
